import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsCollection } from '@fcom/core-api';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

@Component({
  selector: 'cms-badge',
  styleUrls: ['cms-badge.component.scss'],
  templateUrl: 'cms-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsBadgeComponent {
  private themeService = inject(FinnairThemeService);

  content$ = input.required<Observable<CmsCollection>>();

  isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);
}
